import { AuthenticationTypes } from '.';
import * as AuthenticationConstants from './constants';

const logout = (reason) => ({
    type: AuthenticationTypes.LOG_OUT,
    payload: { reason },
});

const setInitialized = (initialized, reason) => ({
    type: AuthenticationTypes.SET_INITIALIZED,
    payload: { initialized, reason },
});

const setAuthenticated = (isAuthenticated) => ({
    type: AuthenticationTypes.SET_AUTHENTICATED,
    payload: { isAuthenticated },
});

const setLoginMethod = (loginMethod) => ({
    type: AuthenticationTypes.SET_LOGIN_METHOD,
    payload: {
        loginMethod,
    },
});

const setUsernameLoginMethod = () => ({
    type: AuthenticationTypes.SET_LOGIN_METHOD,
    payload: {
        loginMethod: AuthenticationConstants.LOGIN_METHOD_USERNAME,
    },
});

const setAuthorizationHeader = (value) => ({
    type: AuthenticationTypes.SET_AUTHORIZATION_HEADER,
    payload: {
        value,
    },
});

const clearAuthorizationHeader = () => ({
    type: AuthenticationTypes.CLEAR_AUTHORIZATION_HEADER,
});

export {
    logout,
    setInitialized,
    setLoginMethod,
    setUsernameLoginMethod,
    setAuthenticated,
    setAuthorizationHeader,
    clearAuthorizationHeader,
};
